/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 *
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 *
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains the component for the select icon.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/**
 * Required to make use of JSX functionality
 */
import React from 'react';

/**
 * Used to show icons.
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * The chevron icon.
 */
import { faChevronDown } from '@fortawesome/pro-duotone-svg-icons/faChevronDown';
import { styled } from '@mui/material';

/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Interfaces
 * ---------------------------------------------------------------------------------
 */
export interface ISelectIconProps {
    className?: string;
}

/*
 * ---------------------------------------------------------------------------------
 * Styles
 * ---------------------------------------------------------------------------------
 */

const StyledIcon = styled(FontAwesomeIcon)(({theme}) => ({
    //top: `calc(50% - 1rem)`,
    fontSize: '1rem',
    position: 'static !important' as any,
    marginRight: theme.spacing(1.75),
    pointerEvents: 'none'
}));

/*
 * ---------------------------------------------------------------------------------
 * components
 * ---------------------------------------------------------------------------------
 */

const SelectIcon: React.FunctionComponent<ISelectIconProps> = ({ className }) => {
    return (
        <StyledIcon icon={faChevronDown} className={className} fixedWidth />
    );
};

/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */

export default SelectIcon;
